'use es6';

import { CRM_OBJECT } from '../constants/dataTypes';
import { CRM_OBJECT_META_TYPE } from '../constants/crmObjectMetaTypes';
export const isCustomObjectReport = report => report.getIn(['config', 'dataType']) === CRM_OBJECT && report.getIn(['config', 'objectTypeId']).startsWith(`${CRM_OBJECT_META_TYPE.PORTAL_SPECIFIC}-`);
export const isCustomObjectType = dataType => dataType.startsWith(`${CRM_OBJECT_META_TYPE.PORTAL_SPECIFIC}-`);
export const isAppObjectType = dataType => dataType.startsWith(`${CRM_OBJECT_META_TYPE.INTEGRATION}-`);